import React, { useEffect,useRef } from 'react'
import './SelectOption.css'
import { useState } from 'react'

const SelectOption = ({Label,options,onclick,resetor,value}) => {

    const [select,setSelect]=useState('--Select an option--')
    //const [hide,setHide]=useState('hide')

    const selecteur=useRef()
    const Options=useRef()

    const Select=(e)=>{
        setSelect(e.currentTarget.innerText)
        selecteur.current.classList.add('current')
        Options.current.classList.add('hide')
        
        //e.currentTarget.parentNode.previousSibling.classList.add('current')
       /* if (hide==='') {
            setHide('hide')
        }
        else {
            setHide('')
        }
*/
        
       // onclick(select)
       onclick(e.currentTarget.innerText)

    }

    const Choose=(e)=>{

        Options.current.classList.toggle('hide')
        selecteur.current.classList.remove('current')
        setSelect('--Select an option--')
        
        //e.currentTarget.nextSibling.classList.toggle('hide')
        //document.querySelector('.selected').classList.toggle('current')
        //e.currentTarget.classList.remove('current')

        /*if (hide==='') {
            setHide('hide')
        }
        else {
            setHide('')
        }
*/
    }

   /*useEffect(() => {
        var Elements=document.getElementsByClassName('options')
       console.log(Elements[2])
   }, [select])
   */

   useEffect(
    ()=>{
        if (resetor===null) {
            Options.current.classList.add('hide')
            selecteur.current.classList.remove('current')
            setSelect('--Select an option--')
         
 
        }

        else {
        }

    }
    ,[resetor]
   )


   useEffect(
    ()=>{
        if (value!==null) {
            Options.current.classList.add('hide')
            selecteur.current.classList.add('current')
            setSelect(value)
            
        }

    }
    ,[value]
   )
  /**/
    

  return (
    <div className='SelectOption'>
        <span>{Label}</span>
        <div className={'selected'} onClick={e=>Choose(e)} ref={selecteur}><span>{select}</span></div>
        <div className={'options hide'} ref={Options}>
            {options.map((option,index)=>{return(<div onClick={e=>Select(e)} key={index}> {option} </div>)})}  
        </div>
    </div>
  )
}

export default SelectOption